$(function () {
	var demo = Vue.createApp({
        delimiters: ['${','}'],
		name: 'Blog',
        data() {
            return {
                blog: window.blog,
                blog_handle: window.blog_handle,
                blog_articles: window.blog_articles,
                blog_tags: window.blog_tags,
                filters: [],
                featured_article_visible: true,
                // perPage: {{ section.settings.limit }},
                page: 1,
                articlesToShow: window.articles_to_show,
                busy: false,
                mounted: false,
                pageHasNextPagination: true,
                showMoreTriggers: 1
            }
        },
        methods: {
            loadAllBlogsRecursively(){
                var self = this;
                if( self.pageHasNextPagination ) {

                    axios.get(`${self.blog_handle.toLowerCase()}?page=${self.page + 1}`)
                    .then(function (response) {
                        var dataAsHTML = document.createElement('div');
                        var parseHTML = $(dataAsHTML).html(response.data);
                        var allPaginatedArticles = parseHTML.find('.paginated-articles .paginate-article-item');

                        if (allPaginatedArticles.length > 0){
                            self.page += 1;

                            allPaginatedArticles.each(function(index, el) {
                                var tempArticle = JSON.parse($(this).find('.article-json').text());
                                // console.log(tempArticle);
                                tempArticle.img_resized = $(this).find('.article-src').text();
                                tempArticle.desc_preview = $(this).find('.article-desc_preview').text();
                                tempArticle.hasBlankImage = ($(this).find('.article-hasBlankImage').text() == 'true');
                                tempArticle.url = $(this).find('.article-url').text();
                                self.blog_articles.push(tempArticle);
                            });

                            if(parseHTML.find('#hasNextPagination').length){
                                console.log('hasNextPagination ID was found, so we are calling the function again recursively:')
                                setTimeout(self.loadAllBlogsRecursively(), 3000);
                            } else {
                                self.pageHasNextPagination = false;
                            }

                        } else {
                            self.pageHasNextPagination = false;
                        }

                        // console.log($(dataAsHTML).html(response.data).find('.paginated-articles .paginate-article-item'));
                        // self.busy = false;

                    })                    
                } else {
                    console.log("all blogs were loaded successfully. no more pages to paginate.");
                }
            },
            loadMore(){
                var self = this;
                if( self.pageHasNextPagination ) {
                self.busy = true;

                    axios.get(`${self.blog_handle.toLowerCase()}?page=${self.page + 1}`)
                    .then(function (response) {
                        var dataAsHTML = document.createElement('div');
                        var parseHTML = $(dataAsHTML).html(response.data);
                        var allPaginatedArticles = parseHTML.find('.paginated-articles .paginate-article-item');

                        if (allPaginatedArticles.length > 0){
                            self.page += 1;

                            allPaginatedArticles.each(function(index, el) {
                                var tempArticle = JSON.parse($(this).find('.article-json').text());
                                // console.log(tempArticle);
                                tempArticle.img_resized = $(this).find('.article-src').text();
                                tempArticle.desc_preview = $(this).find('.article-desc_preview').text();
                                tempArticle.hasBlankImage = ($(this).find('.article-hasBlankImage').text() == 'true');
                                tempArticle.url = $(this).find('.article-url').text();
                                self.blog_articles.push(tempArticle);
                            });

                            if(parseHTML.find('#hasNextPagination').length){
                                console.log('hasNextPagination ID was found, so we are setting the var to true')
                                self.pageHasNextPagination = true;
                            } else {
                                self.pageHasNextPagination = false;
                            }

                        } else {
                            self.pageHasNextPagination = false;
                        }

                        // console.log($(dataAsHTML).html(response.data).find('.paginated-articles .paginate-article-item'));
                        self.busy = false;

                    });
                }
            },
            decodeEscaped(str){
                var element = document.createElement('div');
                    if(str && typeof str === 'string') {
                      str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
                      str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
                      element.innerHTML = str;
                      str = element.textContent;
                      element.textContent = '';
                    }
                return str;                
            },
            filterTags(tag_type){
                return this.blog_tags.filter(function(tag) {return tag.indexOf(tag_type + ':') != -1}).map(function(tag) { return { name:tag.replace(tag_type + ':', ''), id:tag, title:tag_type } })
            },
            clearAllFilters(){
                this.filters = [];
                this.featured_article_visible = true;
                // $.fn.matchHeight._update();
            },
            toggleFilter(filter){
                /*
                 * New ver:
                 * if the filter exists already when you click it then do nothing
                 * otherwise, empty the filters arr to reset the filter and add the clicked filter in
                */

                if ( !this.filters.includes(filter) ){
                    
                    this.filters = [];
                    this.filters = [...this.filters, filter];
                    this.featured_article_visible = false;
                    this.loadMore();
                    // $.fn.matchHeight._update();

                }
            },
            filterIsActive(filter){
                return this.filters.includes(filter);
            },
			triggerFilterToggle() {
				if ($(window).outerWidth() < 640) {
					$('.j-filter-dropdown-toggle').trigger('click');
				}
			},
            extractMatchingTags(article, tag) {
                return article.tags.split(', ').filter(function(item) {
                    return item.indexOf(tag) != -1;
                });
            },
            hasTag(article, tag) {
                return article.tags.includes(tag);
            },
            filteredItems(tag) {
              return this.blog_articles.filter(article => {
                 return article.tags.includes(tag);
              })
            },
            convertOBJtoXML(obj){
              var xml = '';
              for (var prop in obj) {
                xml += obj[prop] instanceof Array ? '' : "<" + prop + ">";
                if (obj[prop] instanceof Array) {
                  for (var array in obj[prop]) {
                    xml += "<" + prop + ">";
                    xml += OBJtoXML(new Object(obj[prop][array]));
                    xml += "</" + prop + ">";
                  }
                } else if (typeof obj[prop] == "object") {
                  xml += OBJtoXML(new Object(obj[prop]));
                } else {
                  xml += obj[prop];
                }
                xml += obj[prop] instanceof Array ? '' : "</" + prop + ">";
              }
              var xml = xml.replace(/<\/?[0-9]{1,}>/g, '');
              return xml
            },    
			generateSrcSet: function(url) {
				if (!url) return '';

				const widths = [180,360,540,720,900,1080,1296,1512,1728,1944,2160,2376,2592,2808,3024];

				const fileTypes = new RegExp(/\.(gif|jpe?g|tiff?|png|webp|avif|bmp)/, 'i');

				return widths.reduce((srcset, width, index) => {
					const fileType = url.match(fileTypes)[0];

					if (url.includes('no-image-')) return url;
 
					return `${srcset} ${url.replace(fileType, `_${width}x${fileType}`)} ${width}w${index < widths.length ? "," : ""}`;
				}, '');
			},
			generateSrcSetFromResized: function(url) {
				if (!url) return '';

				if (url.includes('no-image-')) return url;

				if (!url.includes('_300x300')) {
					return this.generateSrcSet(url);
				}

				const widths = [180,360,540,720,900,1080,1296,1512,1728,1944,2160,2376,2592,2808,3024];

				const fileTypes = new RegExp(/\.(gif|jpe?g|tiff?|png|webp|avif|bmp)/, 'i');

				return widths.reduce((srcset, width, index) => {
					const fileType = url.match(fileTypes)[0];

					const resizedURL = url.replace('_300x300', '');
 
					return `${srcset} ${resizedURL.replace(fileType, `_${width}x${fileType}`)} ${width}w${index < widths.length ? "," : ""}`;
				}, '');
			},
			lazyLoadImages: function () {
				if ("loading" in HTMLImageElement.prototype) {
					var images = document.querySelectorAll('.section--blog-article-listing img[loading="lazy"][data-src]');

					images.forEach(function (image) {
						image.src = image.dataset.src;
						if (image.dataset.srcset) {
							image.srcset = image.dataset.srcset;
						}
					});
				}

				
			}   
        },
        computed: {
            filteredArticles() {
                let _this = this;
                return this.blog_articles.filter(function(article) {
                    let isVisible = false;
                    for(let i in _this.filters) {
                        let tag = _this.filters[i];
                        if(_this.hasTag(article, tag)) {
                            isVisible = true;
                        }
                    }
                    if(_this.filters.length == 0) {
                        return true;
                    }
                    return isVisible;
                })
            },
            totalPages() {
                return Math.ceil(this.filteredArticles.length / this.perPage);
            },
            visableFilteredArticles() {
                return this.filteredArticles.slice( 0, this.page * this.articlesToShow );      
            }
            // pagedArticles() {
            //     return this.filteredArticles.slice( (this.page - 1) * this.perPage, ((this.page - 1) * this.perPage) + this.perPage );
            // }
        },
        created: function() {
            // do nothing
            // this.loadMore();
            // this.loadAllBlogsRecursively();
        },
        mounted: function() {
			this.mounted = true;
			this.lazyLoadImages();
			
			$('.j-article-listing-excerpt').matchHeight();
			$('.j-article-meta').matchHeight();
        },
		updated: function () {

			this.$nextTick(async function() {
				this.lazyLoadImages();

				$('.j-article-listing-excerpt').matchHeight();
				$('.j-article-meta').matchHeight();
			});
		},
        watch: {
            filteredArticles: function(){
                // $.fn.matchHeight._update();
            },
            page: function(){
                // $.fn.matchHeight._update();
                // $.fn.matchHeight._update();
            }
        }
    });

    // Replaces the Vue 2-only `vue-infinite-scroll` plugin (removed - not Vue 3
    // compatible). Preserves the same markup/API used in blog-articles.liquid:
    // v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="articlesToShow"
    // The disabled/distance attributes are plain (non-bound) attribute strings
    // naming a data property on this component, looked up by key - matching how
    // the original plugin resolved them.
    demo.directive('infinite-scroll', {
        mounted(el, binding) {
            const vm = binding.instance;
            const disabledKey = el.getAttribute('infinite-scroll-disabled');
            const distanceKey = el.getAttribute('infinite-scroll-distance');

            function isDisabled() {
                return disabledKey ? !!vm[disabledKey] : false;
            }

            function getDistance() {
                const val = distanceKey ? Number(vm[distanceKey]) : 0;
                return Number.isFinite(val) ? val : 0;
            }

            function checkScroll() {
                if (isDisabled()) return;

                const rect = el.getBoundingClientRect();

                if (rect.bottom - window.innerHeight <= getDistance()) {
                    binding.value();
                }
            }

            el.__infiniteScrollHandler__ = checkScroll;
            window.addEventListener('scroll', checkScroll, { passive: true });
            window.addEventListener('resize', checkScroll);

            // In case the content doesn't fill the viewport on load
            checkScroll();
        },
        unmounted(el) {
            window.removeEventListener('scroll', el.__infiniteScrollHandler__);
            window.removeEventListener('resize', el.__infiniteScrollHandler__);
        }
    });

    demo.mount('#app');
});